import { Injectable } from '@angular/core';
import { Token } from '@domain/entities/session.entity';
import { TokenRepository } from '@domain/repositories/token.repository';
import { Observable, of } from 'rxjs';
import { TokenStorageService } from '../data-services/token-storage.service';

@Injectable()
export class TokenRepositoryImpl implements TokenRepository {
  constructor(private readonly _tokenStorageService: TokenStorageService) {}

  saveToken(token: Token | null): Observable<void> {
    this._tokenStorageService.save(token);
    return of(undefined);
  }

  getToken(): Observable<Token | null> {
    return of(this._tokenStorageService.get());
  }

  removeToken(): Observable<void> {
    this._tokenStorageService.remove();
    return of(undefined);
  }
}
